import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgTime = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20m0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16m-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41z"
      fill="currentColor"
    />
  </svg>
);
